module.exports = __webpack_public_path__ + "img/b-bg.e82f4a6c.png";